import { getSortedConfigurationsOnView } from '@/model/draft/getSortedConfigurationsOnView';
import { StoreState } from '@/redux/types';
import { getConfigurationIds } from './getConfigurationIds';
import { getCurrentView } from './getCurrentView';
import { selectConfigurations } from './selectConfigurations';

export function getSortedConfigurationsOnCurrentView(state: StoreState) {
  return getSortedConfigurationsOnView(
    selectConfigurations(state),
    getConfigurationIds(state),
    getCurrentView(state)
  );
}
